import { OrderType } from 'types';

export enum OrderState {
	inProgress = 'in-progress',
	done = 'done',
	paid = 'paid',
	invoiced = 'invoiced',
}

export interface Order {
	id: number;
	type: OrderType;
	client: {
		id: number;
		name: string;
		phone: string;
	};
	contact: string | null;
	address: string;
	deliveryDate: string;
	claimingDate: string | null;
	wasteType: string;
	state: OrderState;
}
